// noinspection ExceptionCaughtLocallyJS

import { ACTION, setLoading, wrap } from './index';
import * as constants from '../constants';
import legacyApi from '../middlewares/api';
import { Dispatch } from 'redux';
import { SchemaGetIndustriesQueryParams, SchemaPostFiltersRequestBody } from '@repo/legacy-commerce-api';

export const fetchIndustries = (params: SchemaGetIndustriesQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.GET('/industry', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      if (params.context === 'big5') {
        dispatch({
          type: constants.FETCHED_INDUSTRIES_BIG5,
          payload: data.data,
        });
      } else {
        dispatch({ type: constants.FETCHED_INDUSTRIES, payload: data.data });
      }

      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'FETCH_ERROR');

export const updateIndustryAndClearBasket = (payload: string): ACTION => ({
  type: constants.UPDATE_INDUSTRY_AND_CLEAN_BASKET,
  payload,
});

export const updateIndustry = (payload: string): ACTION => ({
  type: constants.UPDATE_INDUSTRY,
  payload,
});

export const updateStartDate = (payload: (string | number)[]): ACTION => ({
  type: constants.UPDATE_START_DATE,
  payload,
});
export const updateDuration = (payload: number): ACTION => ({
  type: constants.UPDATE_DURATION,
  payload,
});

// Unused action:
export const fetchProductFilters = () =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.GET('/productfilter');

      if (error) {
        throw JSON.stringify(error);
      }

      // @ts-expect-error not known return data type:
      dispatch({ type: constants.FETCHED_PRODUCT_FILTERS, payload: data.data });
      // @ts-expect-error not known return data type:
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const updateProductFilters = (payload: SchemaPostFiltersRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.POST('/productfilter', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.FETCHED_PRODUCT_FILTERS, payload: data.data });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const setResultsFilters = (payload: Record<string, string[]>): ACTION => ({
  type: constants.SET_RESULTS_FILTERS,
  payload,
});

export const setResultsFiltersVisibility = (payload: boolean) => ({
  type: constants.SET_RESULTS_FILTERS_VISIBILITY,
  payload,
});

export const fetchBookingDates = () =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.GET('/possiblebookingdates');

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.FETCHED_BOOKING_DATES, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'FETCH_ERROR');
